import { render, staticRenderFns } from "./Declarante.vue?vue&type=template&id=fde90cdc&scoped=true&"
import script from "./Declarante.vue?vue&type=script&lang=js&"
export * from "./Declarante.vue?vue&type=script&lang=js&"
import style0 from "./Declarante.vue?vue&type=style&index=0&id=fde90cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde90cdc",
  null
  
)

export default component.exports